const isPlainObject = require('lodash.isplainobject');
const lodashToString = require('lodash.tostring');

const DEFAULT_LOCALE = 'en';

function getNumberIfSet(value) {
  return value !== undefined ? Number(value) : value;
}

function cast(value, type, options = {}) {
  switch (type) {
    case 'array':
      return value === undefined || value === null ? [] : [value];
    case 'string':
      return isPlainObject(value) ? JSON.stringify(value) : lodashToString(value);
    case 'number':
      return formatNumber(value, options);
    case 'float':
      if (typeof value === 'string') {
        // eslint-disable-next-line no-param-reassign
        value = value.replace(/,/g, '');
      }
      return parseFloat(value);
    case 'integer':
      return parseInt(value, 10);
    case 'date':
      return new Date(value);
    case 'boolean':
      return !!value;
    default:
      return value;
  }
}

function formatNumber(value, options) {
  if (!Object.entries(options).length) return Number(value);

  const { locale = process.env.BLAZE_LOCALE || DEFAULT_LOCALE, ...formatterProps } = options;
  const formatter = new Intl.NumberFormat(locale, formatterProps);
  return formatter.format(value);
}

function base64ToJSON(base64String) {
  try {
    const buff = Buffer.from(base64String, 'base64');
    return JSON.parse(buff.toString());
  } catch (err) {
    return null;
  }
}

module.exports = {
  getNumberIfSet,
  cast,
  base64ToJSON
};
